export const trigger = (element : HTMLInputElement, eventType : string, isChecked? : boolean) => {
	if ( element.checked !== undefined && isChecked !== undefined )
	{
		element.checked = isChecked;
	}

	const event = document.createEvent(`Event`);
	event.initEvent(eventType, true, true);
	element.dispatchEvent(event);
};



// WEBPACK FOOTER //
// ./app/utils/trigger.ts